import { RoleName, UserInfo } from '../types'

export const isManager = (user: UserInfo): boolean => {
  if (!user.roles) {
    return false
  }
  return (
    user.roles.filter((role) =>
      [RoleName.ClusterManager, RoleName.NetworkManager, RoleName.CompanyManager, RoleName.BuManager].includes(role),
    ).length > 0
  )
}

export const isNetworkManager = (user: UserInfo): boolean => {
  if (!user.roles) {
    return false
  }
  return user.roles.filter((role) => [RoleName.NetworkManager].includes(role)).length > 0
}

export const isClusterManager = (user: UserInfo): boolean => {
  if (!user.roles) {
    return false
  }
  return user.roles.filter((role) => [RoleName.ClusterManager].includes(role)).length > 0
}
export const isCompanyManager = (user: UserInfo): boolean => {
  if (!user.roles) {
    return false
  }
  return user.roles.filter((role) => [RoleName.CompanyManager].includes(role)).length > 0
}

export const isUserHrForCountry = (country: string, userRoles?: RoleName[] | null): boolean => {
  if (!userRoles) {
    return false
  }
  return (
    userRoles
      .filter((employeeRole) => employeeRole.includes('HR_'))
      .filter((employeeRole) => {
        const roleParts = employeeRole.split('_')
        return roleParts[2] === country
      }).length > 0
  )
}
